// extracted by mini-css-extract-plugin
export default {"root":"root__HnVlW","heading":"heading__jQC2W"};